/** 1ページあたりの表示件数 */
export const PAGE_LIMIT = 10;

/**
 * URL パスの pageNo 文字列から数値ページ番号を返す。
 * 未指定の場合は 1。1 未満の場合は 1 に補正。
 * parseInt('abc') のような NaN ケースは移行元の挙動を維持（補正しない）。
 */
export function parsePageNo(pageNo: string | undefined): number {
  let no = pageNo ? parseInt(pageNo) : 1;
  if (no < 1) no = 1;
  return no;
}

/**
 * ページ番号とリミットからオフセットを計算する。
 * 例: pageNo=2, limit=10 → 10
 */
export function computeOffset(pageNo: number, limit: number): number {
  return (pageNo - 1) * limit;
}

/**
 * コンテンツ検索ページの URL を返す。
 * pageNo<=1 の場合はベース URL、それ以外は番号付き URL。
 * onPrev の pageNoState==2→base / else→番号 分岐を統一表現している。
 */
export function buildContentSearchPageUrl(companyCd: string, pageNo: number): string {
  return pageNo <= 1
    ? `/ws/${companyCd}/content/search`
    : `/ws/${companyCd}/content/search/${pageNo}`;
}
